let isServerInitialised = false;
let isClientInitialised = false;

export const initState = {
  setServerInitialised: () => {
    isServerInitialised = true;
  },

  setClientInitialised: () => {
    isClientInitialised = true;
  },

  isServerInitialised: () => isServerInitialised,
  isClientInitialised: () => isClientInitialised,

  reset: () => {
    isServerInitialised = false;
    isClientInitialised = false;
  },
};
